export const roles = {
  listFormat: {
    ADMIN: 'Admin',
    MANAGER: 'Manager',
    USER: 'User',
  },
  api: {
    ADMIN: 'account_owner',
    MANAGER: 'manager',
    USER: 'standard_user',
  },
} as const
